import { render, staticRenderFns } from "./customerStorehouseSelect.vue?vue&type=template&id=000dc270&"
import script from "./customerStorehouseSelect.vue?vue&type=script&lang=js&"
export * from "./customerStorehouseSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports